import React, { useEffect } from 'react'

import { StoreBonusStatusResponse } from '@common/models/bonus'

import { useCartContext } from '@/contexts/CartContext'
import { extractBonusValues, getProgressPercentage } from '@/features/storefronts/_storeBase/bonus/bonusUtils'
import { CartItem } from '@/utils/cart'

export type BonusTrackState = { progressPercentage: number; bonusPoints: number; items: CartItem[] }

type BonusTrackContextValue = {
  states: BonusTrackState[] // contains 2 states: the current and previous states
}

export const BonusTrackContext = React.createContext<BonusTrackContextValue>({
  states: [{ progressPercentage: 0, bonusPoints: 0, items: [] }],
})

type Props = React.PropsWithChildren<{
  bonusStatus: StoreBonusStatusResponse
}>
export function BonusTrackContextProvider({ bonusStatus, children }: Props) {
  const { items } = useCartContext()

  const [states, addBonusTrackState] = React.useState<BonusTrackState[]>([
    { progressPercentage: 0, bonusPoints: 0, items: [] },
  ])

  useEffect(() => {
    const { totalBalance: progressPoints } = extractBonusValues({ bonusStatus, items })
    const progressPercentage = bonusStatus ? getProgressPercentage({ bonusStatus, items }) : 0
    addBonusTrackState((prevStates) => {
      return [
        prevStates[prevStates.length - 1] ?? { progressPercentage: 0, bonusPoints: 0, items: [] },
        { progressPercentage, bonusPoints: progressPoints, items },
      ]
    })
  }, [bonusStatus, items])

  return (
    <BonusTrackContext.Provider
      value={{
        states,
      }}
    >
      {children}
    </BonusTrackContext.Provider>
  )
}
